module.exports = __webpack_public_path__ + "static/media/xray-training-medial-nonflex3.6644f7c1.png";